import * as tslib_1 from "tslib";
import { BaseComponent } from "../../base/base.component";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { Location } from "@angular/common";
import { GenericService } from "../../../crossconcern/services/generic.services";
import { DIM_BREAKPOINT_DESKTOP_WIDTH } from "../../../crossconcern/utilities/properties/base.property";
var FrontPhotosphereComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FrontPhotosphereComponent, _super);
    function FrontPhotosphereComponent(translate, appComponent, router, genericService, photosphereManager, location, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.translate = translate;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.genericService = genericService;
        _this.photosphereManager = photosphereManager;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.isBack = false;
        _this.sphereUUID = null;
        _this.nurseryUUID = null;
        _this.isSidebarOpen = true;
        _this.sidebarMode = "over";
        _this.menuButtonMarginLeft = 0;
        // Array containing only the one nursery (the one with nurseryUUID)
        // Used as a frontsidebar component parameter
        _this.nurseries = [];
        return _this;
    }
    FrontPhotosphereComponent.prototype.ngOnInit = function () {
        this.init();
    };
    FrontPhotosphereComponent.prototype.init = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.getPhotospheres(1, 0, this.nurseryUUID, true)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (photosphereList) {
            _this.nurseries.push(photosphereList.photospheres[0].nursery);
        });
        this.isSidebarOpen = window.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH;
        if (this.isSidebarOpen) {
            this.menuButtonMarginLeft = 300;
        }
        else {
            this.menuButtonMarginLeft = 0;
        }
    };
    // Sidebar
    FrontPhotosphereComponent.prototype.toggleSidebar = function () {
        this.isSidebarOpen = !this.isSidebarOpen;
        if (this.isSidebarOpen) {
            this.menuButtonMarginLeft = 300;
        }
        else {
            this.menuButtonMarginLeft = 0;
        }
    };
    FrontPhotosphereComponent.prototype.refreshSidebar = function () {
        var _this = this;
        setTimeout(function () {
            _this.sidebarElement.triggerRerender();
        }, 900);
    };
    return FrontPhotosphereComponent;
}(BaseComponent));
export { FrontPhotosphereComponent };
